/**
 * Classe responsável por construir as projeções
 * que serão enviadas para o servidor.
 * @author: adalto.junior
 * Date: 03/10/13
 * Time: 16:12
 */


Monet.Builder = Monet.Builder || {};

Monet.Builder.Projection = function () {

    var _fieldsTransients = [];
    var _fieldsToIncluding = [];

    this.projection = {
        fields : [],
        orders : null,
        pagination : null
    };

    this.layout = null;

    this.projection.fields.exists = function (fieldToCompare) {

        var exists = false,
            fieldsLength = this.length;

        for(var i = 0; i < fieldsLength; i++){

            var field = this[i];
            var isNameEquals = field.name === fieldToCompare.name;
            var isEntityColumnsEquals = field.lookupEntityColumn === fieldToCompare.lookupEntityColumn;

            if (isNameEquals && isEntityColumnsEquals) {
                exists = true;
                break;
            }

        }

        return exists;

    };

    var formatFieldsToProjection = function (projection) {

        var filters = ['id'],
            fields = projection.fields,
            fieldsLength = fields.length;

        for (var i = 0; i < fieldsLength; i++) {

            var field = fields[i],
                name = '',
                notIsTransient = true;

            if(field.type !== 'LINK'){

                name = field.name;

                if (_fieldsTransients) {
                    notIsTransient = _fieldsTransients.indexOf(name) === -1;
                }

                if (notIsTransient) {
                    if (field.lookupEntityColumn) {
                        const meta = typeof field.meta === 'string' ? JSON.parse(field.meta) : field.meta;

                        if (meta?.hasMany) {
                            let collectionNameEntityName = meta.hasMany.collectionName || field.name;
                            filters.push(collectionNameEntityName + '.*');
                            if(meta.hasMany.entityName) {
                                const getAttr = (el) => el ? `.${el}` : '';
                                collectionNameEntityName += getAttr(meta.hasMany.entityName);
                                const lookupEntityColumn = getAttr(meta.hasMany.lookupEntityColumn || field.lookupEntityColumn);
                                // TODO: improve "entityColumn" name and use (GMM-1142)
                                const lookupEntitySubColumn = getAttr(meta.hasMany.entityColumn);
                                filters.push(collectionNameEntityName + getAttr('id'));

                                if(lookupEntityColumn === lookupEntitySubColumn) {
                                    filters.push(collectionNameEntityName + lookupEntityColumn);
                                } else {
                                    filters.push(collectionNameEntityName + lookupEntityColumn + lookupEntitySubColumn);
                                }
                            }
                        } else {
                            const fielterLookupId = field.name + '.id';
                            if (filters.indexOf(fielterLookupId) === -1) {
                              filters.push(fielterLookupId);
                            }
                            filters.push(field.name + '.' + field.lookupEntityColumn);
                        }
                    } else {
                        filters.push(field.name);
                    }
                }
            }

        }

        return filters;

    };

    this.getFieldsFromLayout = function (layout) {

        var error = null,
            fields = this.projection.fields,
            iterateSections = null;

        try {

            iterateSections = function (sections) {

                for (var property in sections) {

                    if (typeof sections[property] === 'object') {

                        if (property === 'field') {

                            var field = sections[property];
                            var filedNotIsLink = field.type !== 'LINK';

                            if (!fields.exists(field) && filedNotIsLink) {
                                fields.push(sections[property]);
                            }

                        } else {

                            iterateSections (sections[property]);

                        }

                    }
                }

            };

            if (layout.hasOwnProperty('sections')) {

                for(var i = 0; i < layout.sections.length; i++){

                    iterateSections(layout.sections[i]);

                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    'Layout is not ok.');
                error.console();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get field rom layout', e);
            error.console();

        }

    };

    /**
     * Método para adicionar um fieldTransient.
     * Esses field não podem ser passados na projection
     * @param fieldTransient
     */

    this.addFieldTransient = function (fieldTransient) {

        if (fieldTransient && _fieldsTransients.indexOf(fieldTransient) === -1) {
            _fieldsTransients.push(fieldTransient);
        }

    };

    /**
     * Método para adicionar um array de fields transient
     * @param fields {Array}
     */

    this.addFieldsTransient = function (fieldsTransient) {

        var error = null,
            fieldsTransientLength;

        if (fieldsTransient) {

            fieldsTransientLength = fieldsTransient.length;

            if (fieldsTransientLength) {

                for (var i = 0; i < fieldsTransientLength; i++) {
                    this.addFieldTransient(fieldsTransient[i]);
                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    'Field transient is not array');
                error.console();

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Fields transient is not defined');
            error.console();

        }

    };

    /**
     * Método para adicionar um field a lista de fields da projection
     * @param field {Object} property name
     */

    this.addField = function (field) {

        if (!field.length && field.name && !this.projection.fields.exists(field)) {
            this.projection.fields.push(field);
        }

    };

    /**
     * Método para adicionar um array de fields
     * @param fields {Array}
     */

    this.addFields = function (fields) {

        var error = null,
            fieldsLength = 0;

        if (fields) {

            fieldsLength = fields.length;

            if (fieldsLength) {

                for (var i = 0; i < fieldsLength; i++) {
                    this.addField(fields[i]);
                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    'Field is not array');
                error.console();

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Fields is not defined');
            error.console();

        }

    };

    this.setLayout = function (layout){

        var error = null;

        if (layout) {

            this.layout = layout;

        } else {
            error = new Monet.Exception.ReturnError(this,
                'Layout is undefined.');
            error.console();

        }

    };

    /**
     * Método para setar a ordenação da projection.
     * @param columnToOrders {Array} O array de objetos que deve ter
     * como parâmetro: field: nome do field, order: ASC ou DESC
     */

    this.setOrders = function (columnToOrders) {

        if (columnToOrders) {

            this.projection.orders = columnToOrders;

        }

    };

    /**
     * Método para setar a paginação da projection.
     * @param pagination {Object} O objeto deverá ter dois parametros:
     * first: primeiro resultado da consulta
     * max: máximo de resultados da consulta
     */

    this.setPagination = function (pagination) {

        if (pagination) {

            this.projection.pagination = pagination;

        }

    };

    /**
     * Faz um parse do layout recuperando seus fields
     * e adicionando ao this.projection.fields
     */

    this.parseLayout = function () {

        var error = null;

        if (this.layout) {

            this.getFieldsFromLayout(this.layout);

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Nothing laayout to parse.');
            error.console();

        }

    };

    /**
     * Método que formata a projection retornando uma string
     * @returns {*}
     */

    this.projection.toString = function () {

        var _projection = {};

        _projection.filters = formatFieldsToProjection(this);

        if (_fieldsToIncluding.length) {
            _projection.including = [_fieldsToIncluding.join(',')];
        }

        if (this.pagination) {

            _projection.firstResult = this.pagination.first;
            _projection.maxResults = this.pagination.max;

        }

        return JSON.stringify(_projection);

    };

    this.addFieldsToIncluding = function (fields) {

        for (var i = 0, j = fields.length; i < j; i++) {

            var field = fields[i];

            if (_fieldsToIncluding.indexOf(field) === -1) {
                _fieldsToIncluding.push(field);
            }

        }

    };

};
